import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

/** The Redo supplies catalog, for targeting shipping rules at products. */
export const getSuppliesCatalogProducts = {
  name: "getSuppliesCatalogProducts" as const,
  input: z.object({}),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
      }),
    ),
  }),
};
